import { render, staticRenderFns } from "./IconInboxInOutline.vue?vue&type=template&id=c64aa4b8"
import script from "./IconInboxInOutline.vue?vue&type=script&lang=js"
export * from "./IconInboxInOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports